import React, {useState}   from "react";
import { useSearchParams } from "react-router-dom";
import InstructorForm from "./InstructorForm";
import InstructorSearch from "./InstructorSearch";
import InstructorTable from "./InstructorTable";

const Instructor = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedData, setSelectedData] = useState(null);

  const searchParam = {
    outYn: searchParams.get("outYn") || "",
    searchCnd: searchParams.get("searchCnd") || "",
    searchWrd: searchParams.get("searchWrd") || "",
  };

  const handleSearch = (data) => {
    const newParams = new URLSearchParams();
    newParams.set("pageIndex", "1");
    if (data.outYn) newParams.set("outYn", data.outYn);
    if (data.searchCnd) newParams.set("searchCnd", data.searchCnd);
    if (data.searchWrd) newParams.set("searchWrd", data.searchWrd);
    setSearchParams(newParams);
  };

  // 목록 테이블에서 행 클릭 시
  const handleRowClick = (item) => {
    setSelectedData(item);
  };

  // 등록 / 수정 후 (저장 시) 처리: 선택 해제 후 목록 재조회를 위해 URLSearchParams 재설정
  const handleSaved = () => {
    setSelectedData(null);
    setSearchParams((prev) => new URLSearchParams(prev));
  };

  // 등록 / 수정 폼 추가 처리
  const handleAdd = () => {
    setSelectedData(null);
  }

  const resetSearchParams = () => {
    setSearchParams(new URLSearchParams());
  };

  return (
      <div className="contents-wrap">
        <div className="page-title-wrap">
          <h2><span className="icon-dot-circle"></span>강사 정보 관리</h2>
        </div>

        <div className="tab-cont-wrap">
          <div className="tab-cont-01 on">

          <InstructorSearch 
            defaultValues={searchParam} 
            onSearch={handleSearch}
            onReset={resetSearchParams}
          />

            <div className="row-1">
              <section className="wp60 section-wrap">
                <InstructorTable
                  handleRowClick={handleRowClick}
                  selectedId={selectedData?.instructorId}
                />
              </section>
              <section className="wp40">  
                <InstructorForm
                  selectedData={selectedData}
                  onSaved={handleSaved}
                  onAdd={handleAdd}
                />
              </section>  
            </div>
          </div>
        </div>
      </div>
  );
};

export {Instructor};
